import {
  Row,
  Select,
  Typography,
  Input,
  Button,
  Radio,
  Space,
  Col,
  Form,
  Collapse,
  InputNumber,
  notification,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { DOUBLE_REGEX } from "shared/constants/AppConstants";
import { numberWithCommas } from "shared/services/Utility";
import {ReactComponent as IconApprove} from "../../../../assets/images/apporveIcon.svg";
import shareIcon from "../../../../assets/images/shareIcon.svg";
import DocumentStatus from "../RequiredDocuments/DocumentStatus";
import copy from "../../../../assets/images/copy.svg";

import "./index.scss";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "shared/redux/store";
import { setIsLenderDecisionErr } from "shared/redux/lead-reducer";

const { Panel } = Collapse;
const { TextArea } = Input;
const { Title, Text } = Typography;

const LenderDecision: React.FunctionComponent<any> = ({
  assignedLenders,
  lenderDecisionHandler,
  leadData,
  faircentStatus,
  getRedirectURLLink,
  loadingUpdate,
  getDownloadLetterForICICI,
}) => {
  const [selectedLenderData, setSelectedLenderData] = useState([] as any);
  const [rejectReasons, setRejectReasons] = useState([] as any);
  const [pendencyReasons, setPendencyReasons] = useState([] as any);
  const [withdrawnReasons, setWithdrawnReasons] = useState([] as any);
  const [dicisionForm] = Form.useForm();

  const [showDocumentStatus, setShowDocumentStatus] = useState(false);
  const [documentDetails, setDocumentDetails] = useState(null);
  const [selectedLender, setSelectedLender] = useState({} as any);
  const {appColors}: any = useSelector((state: RootState) => state.common);
  const leadReducer:any = useSelector((state: RootState) => state.lead); 
  const dispatch = useDispatch();

  //TODO: ICICI demo report Download
  const base64 =
    "data:application/pdf;base64,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";

  useEffect(() => {
    let enumValues = localStorage.getItem("enumValues") as any;
    if (enumValues) {
      enumValues = JSON.parse(enumValues);
      const rejectedReasonList = enumValues.find(
        (item) => item.propertyName === "REJECTION_REASON"
      );
      const rejectedReasonListDisplay =
        rejectedReasonList.keyAndDisplayValueList?.filter((item: any) => {
          return (
            item?.key == "FRAUD_CASE" ||
            item?.key == "LOAN_SIZE_SMALL" ||
            item?.key == "LIMIT_EXHAUSTED" ||
            item?.key == "INCOMPLETE_DOCUMENTS" ||
            item?.key == "VERTICAL_NOT_SUPPORTED" ||
            item?.key == "CREDIT_SCORE_INSUFFICIENT" ||
            item?.key == "OUTSIDE_GEOGRAPHIC_JURISDICTION" ||
            item?.key == "DUPLICATE"
          );
        });
      setRejectReasons(rejectedReasonListDisplay);
      const pendencyReasonList = enumValues?.find(
        (item) => item?.propertyName === "PENDENCY_REASON"
      );
      setPendencyReasons(pendencyReasonList?.keyAndDisplayValueList);
      const withdrawnReasonList = enumValues?.find(
        (item) => item?.propertyName === "WITHDRAWN_REASON"
      );
      setWithdrawnReasons(withdrawnReasonList?.keyAndDisplayValueList);
    }
    let sanctionedAmount = 0;
    let lenderDecisionType = [] as any;
    const tmpAssignedLenders = assignedLenders.filter(
      (item) =>
        (item.status === "LOGGED" && item?.submissionType != "API") ||
        (item?.submissionType == "API" && item?.allDocumentUploaded) ||
        item.status == "PENDENCY" ||
        item.status === "SANCTIONED" ||
        item.status === "DISBURSED" ||
        item.status === "REJECTED" ||
        item.status === "WITHDRAWN"
    );
    tmpAssignedLenders?.map(
      (item, index) => (
        (item.leanderDecision = {
          selectedType: getSelectedType(item),
          sanctionedData: {
            interestRate: item.interestRate,
            loanAmount: item.sanctionedAmount,
            sanctionedDate: item?.sanctionedDate,
          },
          rejectedData: { [`rejectReason${index}`]: item.rejectedReason },
          pendencyData: { [`comment${index}`]: item?.comments },
          withdrawnData: { [`comment${index}`]: item?.comments },
          interestRate: item.interestRate,
        }),
        lenderDecisionType.push({
          selectedType: getSelectedType(item),
        }),
        (sanctionedAmount += item.sanctionedAmount ?? 0)
      )
    );
    setSelectedLenderData(tmpAssignedLenders);
    const setData = {} as any;
    tmpAssignedLenders.map((lender: any, index: number) => {
      const selectedType =
        lender?.status == "DISBURSED"
          ? "Disbursed"
          : lender?.leanderDecision?.selectedType ?? undefined;
      setData[`selectedType${index}`] = selectedType;
      if (selectedType == 1) {
        const sanctionedData = {
          ...lender?.leanderDecision?.sanctionedData,
          sanctionedDate: lender?.leanderDecision?.sanctionedData
            ?.sanctionedDate
            ? moment(lender?.leanderDecision?.sanctionedData?.sanctionedDate)
            : "",
        };
        setData[`${index}`] = sanctionedData;
      } else if (selectedType == 2) {
        setData[`rejectReason${index}`] =
          lender?.leanderDecision?.rejectedData?.rejectReason ?? undefined;
      } else if (selectedType == 3) {
        setData[`comment${index}`] =
          lender?.leanderDecision?.withdrawnData[`comment${index}`] ??
          undefined;
      } else if (selectedType == 4) {
        setData[`comment${index}`] =
          lender?.leanderDecision?.pendencyData[`comment${index}`] ?? undefined;
      } else {
        const sanctionedData = {
          ...lender?.leanderDecision?.sanctionedData,
          disbursedAmount: calcTotalDisbursedAmount(
            lender?.disbursalLenderInfoDetails
          ),
        };
        setData[`${index}`] = sanctionedData;
      }
    });

    const loanAmount = leadData.caseDetails?.loanDetails?.loanAmount || 0;
    dicisionForm.setFieldsValue({
      ...setData,
      approvedAmount: sanctionedAmount,
      requestedAmount: loanAmount,
    });
    dispatch(setIsLenderDecisionErr(false));
  }, [leadReducer?.isLenderDecisionErr ||leadData]);

  const calcTotalDisbursedAmount = (disbursalLenderInfoDetails) => {
    let amountDisbursed = disbursalLenderInfoDetails?.map((item) =>
      Number(item.lenderAmount.disbursedAmount)
    );
    let amountInsurance = disbursalLenderInfoDetails?.map((item) =>
      Number(item.lenderAmount.insuranceAmount)
    );
    const totalDisbursed = amountDisbursed?.reduce((a, b) => a + b, 0);
    const totalInsurance = amountInsurance?.reduce((a, b) => a + b, 0);
    const total = totalDisbursed + totalInsurance;
    return isNaN(total) ? 0 : total;
  };

  const getSelectedType = (item) => {
    if (
      faircentStatus?.toUpperCase() === "SANCTIONED" ||
      item.status == "SANCTIONED" ||
      item.status == "DISBURSED"
    ) {
      return 1;
    } else if (faircentStatus === "Rejected" || item.status == "REJECTED") {
      return 2;
    } else if (item.status == "WITHDRAWN") {
      return 3;
    } else if (item.status == "PENDENCY") {
      return 4;
    }
    return null;
  };

  const onChangeHandler = (ev: any, i: number) => {
    let lenders = [...selectedLenderData];
    lenders[i].leanderDecision["selectedType"] = ev;
    lenders[i].isChanged = true;
    setSelectedLenderData(lenders);
    const setData = {} as any;
    if (ev == 1) {
      setData[`${i}`] = {...lenders[i]?.leanderDecision?.sanctionedData};
    }else if(ev == 2){
      setData[`rejectReason${i}`] = lenders[i]?.leanderDecision?.rejectedData?.rejectReason ?? ""
    }
    dicisionForm.setFieldsValue({ ...setData });
    let field = dicisionForm.getFieldValue(`${i}`);
    if (ev == 2) {
      let total = dicisionForm.getFieldValue("approvedAmount");
      if (field) {
        total = total - field.loanAmount;
      }else{
        total = total - lenders[i]?.sanctionedAmount
      }
      dicisionForm.setFieldsValue({ names: field, approvedAmount: total });
    }
    if (ev !== 2) {
      let total = 0;
      lenders?.forEach(item => {
        if (item?.leanderDecision?.selectedType != 2) {
          total += item?.sanctionedAmount
        }
      });
      dicisionForm.setFieldsValue({ names: field, approvedAmount: total });
    }
  };

  const lenderSanctionedHandler = (value: any) => {
    const lenders = selectedLenderData?.filter(
      (lader: any) => lader?.status == "LOGGED" || lader?.isChanged
    );

    lenders?.map((item: any, i: number) => {
      const tmpObj = {
        selectedType: item?.leanderDecision?.selectedType,
        sanctionedData: {
          interestRate: item?.leanderDecision?.sanctionedData?.interestRate,
          loanAmount: item?.leanderDecision?.sanctionedData?.loanAmount,
          sanctionedDate: item?.leanderDecision?.sanctionedData?.sanctionedDate,
        },
        rejectedData: {
          [`rejectReason${i}`]: Object.values(
            item?.leanderDecision?.rejectedData
          )?.at(0),
        },
        pendencyData: {
          [`comment${i}`]: Object.values(
            item?.leanderDecision?.pendencyData
          )?.at(0),
        },
        withdrawnData: {
          [`comment${i}`]: Object.values(
            item?.leanderDecision?.withdrawnData
          )?.at(0),
        },
        interestRate: item?.leanderDecision?.interestRate,
      };
      item.leanderDecision = tmpObj;
    });

    const data = {
      lenders,
      comment: value?.comment ?? "",
      requestedAmount: value?.requestedAmount ?? 0,
      approvedAmount: value?.approvedAmount ?? 0,
    };
    lenderDecisionHandler(data);
  };

  const decisionHandler = (event: any, i: number, customName?: string) => {
    const lenders = [...selectedLenderData];
    let fieldName = event?.target?.name ? event.target.name : customName;
    let fieldValue = event?.target?.value ? event.target.value : event;
    if (lenders[i].leanderDecision.selectedType === 1) {
      lenders[i].leanderDecision.sanctionedData[fieldName] = fieldValue;

      let amount = lenders.map((item) =>
        Number(item.leanderDecision.sanctionedData.loanAmount)
      );
      const total = amount.reduce((a, b) => a + (isNaN(b) ? 0 : b), 0);
      dicisionForm.setFieldsValue({ approvedAmount: total });
    }
    if (lenders[i].leanderDecision.selectedType === 2) {
      lenders[i].leanderDecision.rejectedData[fieldName] = fieldValue;
    }
    if (lenders[i].leanderDecision.selectedType === 3) {
      lenders[i].leanderDecision.withdrawnData[fieldName] = fieldValue;
    }
    if (lenders[i].leanderDecision.selectedType === 4) {
      lenders[i].leanderDecision.pendencyData[fieldName] = fieldValue;
    }
    lenders[i].isChanged = true;
    setSelectedLenderData(lenders);
  };
  const renderDocumentStatus = (lender) => {
    const total = lender?.documentProgressDetails?.totalNumberOfDocs ?? 0;
    const submitted =
      lender?.documentProgressDetails?.documentsSuccessfullySubmitted ?? 0;
    const failed = lender?.documentProgressDetails?.failure ?? 0;
    return (
      <>
        {total > 0 && (submitted > 0 || failed > 0) && (
          <span
            style={{ cursor: "pointer", fontSize: "11px", float: "right" }}
            onClick={() => {
              setDocumentDetails(
                lender?.documentProgressDetails?.submissionDetails
              );
              setSelectedLender(lender);
              setShowDocumentStatus(true);
            }}
          >
            {`Document Status: ${submitted}/${total}`}
          </span>
        )}
      </>
    );
  };

  const btnPrimaryStyles : any = {'--btnColor' :appColors?.appPrimaryColor ?? ""};

  const renderWithdraw = (item: any, i: any) => {
    return (
      <div className="rejected-wrapper">
        <Text className="fields-text">Withdrawn Reason</Text>
        <Form.Item
          name={`comment${i}`}
          // initialValue={item.rejectedReason}
        >
          <Select
            className="custom-select"
            showSearch
            placeholder="Select Reason"
            optionFilterProp="children"
            onChange={(ev) => {
              decisionHandler(ev, i, `comment${i}`);
            }}
            filterOption={(input, option) =>
              (option!.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {withdrawnReasons?.map((item) => (
              <Select.Option key={item?.key} value={item?.key}>
                {item?.value}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>
    );
  };

  const renderPendency = (item: any, i: any) => {
    return (
      <div className="rejected-wrapper">
        <Text className="fields-text ">Pendency Reason</Text>
        <Form.Item
          name={`comment${i}`}
          // initialValue={item.rejectedReason}
        >
          <Select
            className="custom-select"
            showSearch
            placeholder="Select Reason"
            optionFilterProp="children"
            onChange={(ev) => {
              decisionHandler(ev, i, `comment${i}`);
            }}
            filterOption={(input, option) =>
              (option!.children as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          >
            {pendencyReasons?.map((item) => (
              <Select.Option key={item?.key} value={item?.key}>
                {item?.value}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </div>
    );
  };

  const getHeader = (item) => {
    let consentDetails: any = {};
    if ((item?.consentDetails?.length ?? 0) > 0) {
      consentDetails = JSON.parse(item?.consentDetails ?? {});
    }

    return (
      <>
        <div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <h4>{item.lenderName}</h4>
            {Object.keys(consentDetails).length > 0 && (
              <Tooltip title={`Time stemp: ${consentDetails?.timeStamp}`}>
                <span className="api-intergrated-text" style={{"--appSecondary": appColors?.appSecondaryColor ?? ""} as any}>
                  <IconApprove /> {"Consent"}
                </span>
              </Tooltip>
            )}
          </div>
          {item?.submissionType?.includes("API") && (
            <Space>
              <span className="api-intergrated-text" style={{"--appSecondary": appColors?.appSecondaryColor ?? ""} as any}>
                <IconApprove /> {"API"}
              </span>
              {/* {item?.lenderApplicationId !== null ? (
            ) : (
              ""
            )}{" "} */}
            </Space>
          )}
        </div>
        {/* <h6>{item.hubName}</h6> */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          { !item?.lenderName?.toLowerCase()?.includes("bajaj housing finance") && item?.submissionType?.includes("API") &&
            (item?.lenderApplicationId?.length ?? 0) > 0 && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <span
                  style={{ fontSize: "11px", float: "left" }}
                >{`Lender loan ID: ${item.lenderApplicationId}`}</span>
              </div>
            )}
          {renderDocumentStatus(item)}
        </div>
        {/* inCred customer id display  */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {(item?.additionalFields?.length ?? 0) > 0 && JSON.parse(item?.additionalFields)?.customerId?.length && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <span
                  style={{ fontSize: "11px", float: "left" }}
                >{`Customer ID: ${JSON.parse(item?.additionalFields)?.customerId}`}</span>
              </div>
            )}
          {renderDocumentStatus(item)}
        </div>


        {/* BAJAJ HOSUING FINANCE Changes */}

        {  item?.lenderName?.toLowerCase()?.includes("bajaj housing finance")  && (
                  <div className="checkbox-text-div">
                    {item?.submissionType?.includes("API") &&
                      item?.additionalFields?.length > 0 &&
                      item?.lenderName?.toLowerCase()?.includes("bajaj housing finance") && (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span className="checkbox-text small">{`Lender lead ID: ${JSON.parse(item?.additionalFields)?.leadId}`}</span>
                          <Button
                            style={{
                              borderColor: "transparent",
                              fontSize: "12px",
                            }}
                            size="small"
                            shape="circle"
                            onClick={() => {
                              navigator.clipboard.writeText(
                                JSON.parse(item?.additionalFields)?.leadId ??
                                  ""
                              );
                              notification.success({
                                message: "Copied to clipboard",
                              });
                            }}
                            icon={<img src={copy} alt="" width={12} />}
                          />
                        </div>
                      )}
                  </div>
                  
                )}

                {  item?.lenderName?.toLowerCase()?.includes("bajaj housing finance")  && (
                  <div className="checkbox-text-div">
                    {item?.submissionType?.includes("API") &&
                      item?.additionalFields?.length > 0 &&
                      item?.lenderName?.toLowerCase()?.includes("bajaj housing finance") && (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span className="checkbox-text small">{`Lender Offer ID: ${JSON.parse(item?.additionalFields)?.offerId}`}</span>
                          <Button
                            style={{
                              borderColor: "transparent",
                              fontSize: "12px",
                            }}
                            size="small"
                            shape="circle"
                            onClick={() => {
                              navigator.clipboard.writeText(
                                JSON.parse(item?.additionalFields)?.offerId ??
                                  ""
                              );
                              notification.success({
                                message: "Copied to clipboard",
                              });
                            }}
                            icon={<img src={copy} alt="" width={12} />}
                          />
                        </div>
                      )}
                  </div>
                  
                )}


        <div className="" style={{ display: "flex" }}>
          {item?.submissionType?.includes("API") &&
            item?.additionalFields?.length > 0 &&
            item?.lenderName?.toLowerCase()?.includes("icici") && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ fontSize: "11px", float: "left" }}>{`iLens ID: ${
                  JSON.parse(item?.additionalFields)?.ilensId
                }`}</span>
                <Button
                  style={{ borderColor: "transparent", fontSize: "12px" }}
                  size="small"
                  shape="circle"
                  onClick={() => {
                    navigator.clipboard.writeText(
                      JSON.parse(item?.additionalFields)?.ilensId ?? ""
                    );
                    notification.success({ message: "Copied to clipboard" });
                  }}
                  icon={<img src={copy} alt="" width={12} />}
                />
              </div>
            )}
        </div>
        <div className="" style={{ display: "flex" }}>
          {item?.submissionType?.includes("API") &&
            item?.additionalFields?.length > 0 &&
            item?.lenderName?.toLowerCase()?.includes("icici") && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <span
                  style={{ fontSize: "11px", float: "left" }}
                >{`Application Form No: ${
                  JSON.parse(item?.additionalFields)?.applicationFormNo
                }`}</span>
                <Button
                  style={{ borderColor: "transparent", fontSize: "12px" }}
                  size="small"
                  shape="circle"
                  onClick={() => {
                    navigator.clipboard.writeText(
                      JSON.parse(item?.additionalFields)?.applicationFormNo ??
                        ""
                    );
                    notification.success({ message: "Copied to clipboard" });
                  }}
                  icon={<img src={copy} alt="" width={12} />}
                />
              </div>
            )}
        </div>
        <div style={{ display: "flex", marginBottom: "5px" }}>
          {item?.submissionType?.includes("API") &&
            (item?.lenderApplicationId?.length ?? 0) > 0 && (
              <span className="">
                {(["BU9709497975", "BU3620294738"].includes(
                  item.lenderInfoId
                ) ||
                  item?.lenderName?.toLowerCase()?.includes("icici")) && (
                  <>
                    <a
                      className="small"
                      style={{ fontSize: "12px" }}
                      onClick={() => {
                        getDownloadLetterForICICI(item?.lenderInfoId);
                      }}
                    >
                      {item.lenderName.split(" ")[0]} Download letter
                    </a>
                  </>
                )}
              </span>
            )}
        </div>
        {item?.submissionType?.includes("API") &&
          (item?.lenderApplicationId?.length ?? 0) > 0 && (
            <span className="flex" style={{ display: "flex" }}>
              {(["BU9709497975", "BU3620294738"].includes(item.lenderInfoId) ||
                item?.lenderName?.toLowerCase()?.includes("fibe") ||
                item?.lenderName.toLowerCase().includes("nira finance") ||
                item?.lenderName?.toLowerCase()?.includes("moneywide") ||
                item?.lenderName?.toLowerCase()?.includes("cashe") ||
                item?.lenderName?.toLowerCase()?.includes("kreditbee") ||
                item?.lenderName?.toLowerCase()?.includes("abcfl") ||
                item?.lenderName?.toLowerCase()?.includes("abcl") ||
                item?.lenderName?.toLowerCase()?.includes("prefr") ||
                item?.lenderName?.toLowerCase()?.includes("incred") ||
                item?.lenderName?.toLowerCase()?.includes("credilio")) && (
                <>
                  <a
                    onClick={() =>
                      getRedirectURLLink(
                        item?.lenderInfoId,
                        leadData?.loanProductId,
                        item?.lenderApplicationId
                      )
                    }
                    className="small"
                    style={{ fontSize: "12px" }}
                  >
                    {item?.lenderName?.toLowerCase()?.includes("abcfl") ||
                    item?.lenderName?.toLowerCase()?.includes("abcl")
                      ? "ABCL Dashboard"
                      : `${item.lenderName.split(" ")[0]} Dashboard`}
                  </a>
                  <Button
                    size="small"
                    style={{ margin: "2px", border: "none" }}
                    onClick={() =>
                      getRedirectURLLink(
                        item?.lenderInfoId,
                        leadData?.loanProductId,
                        item?.lenderApplicationId,
                        true
                      )
                    }
                    icon={
                      <img
                        src={shareIcon}
                        alt=""
                        width={18}
                        height={18}
                        style={{ marginTop: "-4px" }}
                      />
                    }
                  />
                </>
              )}
            </span>
          )}
      </>
    );
  };

  return (
    <div>
      {showDocumentStatus && (
        <DocumentStatus
          showDocumentStatus={showDocumentStatus}
          setShowDocumentStatus={setShowDocumentStatus}
          lenderInfoId={selectedLender?.lenderInfoId}
          caseId={leadData?.caseDetails?.caseId}
          documentDetails={documentDetails}
        />
      )}
      <Title level={5}>Lender Decision</Title>
      <Form form={dicisionForm} onFinish={lenderSanctionedHandler}>
        <Space className="lender-space" direction="vertical">
          {selectedLenderData?.map((item: any, i: any) => (
            <div key={i}>
              <Collapse
                // className="lender-collapse"
                className="payout-collapse"
                collapsible="header"
                defaultActiveKey={[i === 0 ? "1" : ""]}
                expandIconPosition="end"
              >
                <Panel header={getHeader(item)} key="1">
                  <div
                    className="assigned-lender-list"
                    style={{ paddingInline: "16px" }}
                  >
                    <div className="lender-decision-header">
                      <Form.Item name={`selectedType${i}`}>
                        <Select
                          className="custom-select"
                          onSelect={(ev: any) => {
                            onChangeHandler(ev, i);
                          }}
                          disabled={item?.status == "DISBURSED"}
                        >
                          <Select.Option value={1}>Sanctioned</Select.Option>
                          <Select.Option value={2}>Rejected</Select.Option>
                          <Select.Option value={3}>WithDrawn</Select.Option>
                          <Select.Option value={4}>Pendency</Select.Option>
                        </Select>
                      </Form.Item>
                      {/* <Radio.Group
                        className="lender-dec-tab"
                        name="selectedType"
                        onChange={(ev) => onChangeHandler(ev, i)}
                        value={item.leanderDecision.selectedType}
                        disabled={item?.status == "DISBURSED"}
                      >
                        <Radio value={1}>Sanctioned</Radio>
                        <Radio value={2}>Rejected</Radio>
                        <Radio value={3}>Withdrawn</Radio>
                      </Radio.Group> */}
                    </div>
                    {item.leanderDecision.selectedType === 1 && (
                      <div className="lender-list-wrapper">
                        <Form.List name={i}>
                          {(fields) => (
                            <Row gutter={[8, 8]}>
                              <Col span={12}>
                                <Form.Item
                                  name="interestRate"
                                  label="Interest rate %"
                                  className="inline-label"
                                  initialValue={
                                    item?.leanderDecision?.interestRate || 0
                                  }
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter interest rate %",
                                    },
                                    {
                                      pattern: DOUBLE_REGEX,
                                      message:
                                        "Please enter valid interest rate %",
                                    },
                                  ]}
                                >
                                  <Input
                                    className="custom-input"
                                    name="interestRate"
                                    disabled={item.status == "DISBURSED"}
                                    value={item.leanderDecision.interestRate}
                                    onChange={(ev) => decisionHandler(ev, i)}
                                    placeholder="Interest rate %"
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item
                                  name="loanAmount"
                                  className="inline-label"
                                  label="Amount"
                                  initialValue={item?.sanctionedAmount ?? 0}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Please enter amount",
                                    },
                                  ]}
                                >
                                  <InputNumber
                                    className="custom-input-number"
                                    name="loanAmount"
                                    disabled={item.status == "DISBURSED"}
                                    formatter={(value) =>
                                      numberWithCommas(value)
                                    }
                                    onChange={(ev) =>
                                      decisionHandler(ev, i, "loanAmount")
                                    }
                                    placeholder="Amount"
                                  />
                                </Form.Item>
                              </Col>
                            </Row>
                          )}
                        </Form.List>
                      </div>
                    )}
                    {item.leanderDecision.selectedType === 2 && (
                      <div className="rejected-wrapper">
                        <Row gutter={[16, 16]}>
                          <Col span={24}>
                            <Text className="fields-text">Rejected Reason</Text>
                            <Form.Item
                              name={`rejectReason${i}`}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select reason",
                                },
                              ]}
                              initialValue={item.rejectedReason}
                            >
                              <Select
                                className="custom-select"
                                showSearch
                                placeholder="Select Reason"
                                optionFilterProp="children"
                                onChange={(ev) => {
                                  decisionHandler(ev, i, `rejectReason${i}`);
                                }}
                                filterOption={(input, option) =>
                                  (option!.children as unknown as string)
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                              >
                                {rejectReasons?.map((item) => (
                                  <Select.Option
                                    key={item.key}
                                    value={item.key}
                                  >
                                    {item.value}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    )}
                    {item.leanderDecision.selectedType === 3 &&
                      renderWithdraw(item, i)}
                    {item.leanderDecision.selectedType === 4 &&
                      renderPendency(item, i)}
                  </div>
                </Panel>
              </Collapse>
            </div>
          ))}
        </Space>

        <Col span={24} style={{ marginTop: "20px" }}>
          <Form.Item
            name="requestedAmount"
            className="inline-label"
            label="Requested Amount"
            rules={[
              { required: true, message: "Please enter requested amount" },
            ]}
          >
            <InputNumber
              readOnly
              className="custom-input-number"
              name="requestedAmount"
              formatter={(value) => numberWithCommas(value)}
              placeholder="Requested Amount"
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name="approvedAmount"
            className="inline-label"
            label="Approved Amount"
            rules={[
              { required: true, message: "Please enter approved amount" },
            ]}
          >
            <InputNumber
              className="custom-input-number"
              name="approvedAmount"
              readOnly
              formatter={(value) => numberWithCommas(value)}
              placeholder="Approved Amount"
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item className="comment-box" name="comment">
            <TextArea
              name="comment"
              placeholder="Comment"
              showCount
              maxLength={500}
              className="custom-textarea"
            />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item name="next">
            <Button
              type="primary"
              htmlType="submit"
              className="next-btn dynamic-btn-primary"
              style={btnPrimaryStyles}
              loading={loadingUpdate}
              // disabled={
              //   selectedLenderData?.[0]?.leanderDecision?.selectedType == 0
              //     ? true
              //     : false
              // }
              disabled={
                !selectedLenderData?.some(
                  (item: any) => item?.leanderDecision?.selectedType != 0
                )
              }
            >
              Next Stage
            </Button>
          </Form.Item>
        </Col>
      </Form>
    </div>
  );
};

export default LenderDecision;
